const NAVBAR_OFFSET = 170

export const scrollToElement = (selector?: string, ms = 1000) => {
  // Wait element to be in view
  setTimeout(() => {
    const element = selector ? document.querySelector(selector) : ''

    if (element) {
      const topY = element.getBoundingClientRect().top + window.pageYOffset - NAVBAR_OFFSET

      window.scrollTo({ top: topY, behavior: 'smooth' })
    }
  }, ms)
}

export const scrollToIssue = (issueId: string, ms?: number) => {
  scrollToElement(`[data-test="issue-row-${issueId}"]`, ms)
}
